import {
  FETCH_COVERAGE_GROUPS_REQUEST,
  FETCH_COVERAGE_GROUPS_SUCCESS,
  FETCH_COVERAGE_GROUPS_FAILURE,
  FETCH_COVERAGES_BY_GROUP_REQUEST,
  FETCH_COVERAGES_BY_GROUP_SUCCESS,
  FETCH_COVERAGES_BY_GROUP_FAILURE,
  FETCH_COVERAGE_GROUP_BY_ID_REQUEST,
  FETCH_COVERAGE_GROUP_BY_ID_SUCCESS,
  FETCH_COVERAGE_GROUP_BY_ID_FAILURE,
  CREATE_COVERAGE_GROUP_REQUEST,
  CREATE_COVERAGE_GROUP_SUCCESS,
  CREATE_COVERAGE_GROUP_FAILURE,
  EDIT_COVERAGE_GROUP_REQUEST,
  EDIT_COVERAGE_GROUP_SUCCESS,
  EDIT_COVERAGE_GROUP_FAILURE,
  DELETE_COVERAGE_GROUP_REQUEST,
  DELETE_COVERAGE_GROUP_SUCCESS,
  DELETE_COVERAGE_GROUP_FAILURE,
  SET_SELECTED_COVERAGE_GROUP,
  ADD_COVERAGE_GROUP_MODE,
  EDIT_COVERAGE_GROUP_MODE,
  DELETE_COVERAGE_GROUP_MODE,
  CLEAR_COVERAGE_GROUPS
} from '../../actions/coverageGroups/coverageGroupsActions';

const initialState = {
  coverageGroups: [],
  availableCoverages: [],
  coverageGroupSelected: null,
  coverageGroupDetail: null,
  addMode: false,
  deleteMode: false,
  addCoverageGroup: true,
  isLoading: false,
  error: null,
  config: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: []
  }
};

export const coverageGroupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COVERAGE_GROUPS_REQUEST:
    case CREATE_COVERAGE_GROUP_REQUEST:
    case EDIT_COVERAGE_GROUP_REQUEST:
    case DELETE_COVERAGE_GROUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };

    case FETCH_COVERAGE_GROUPS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        coverageGroups: action.payload,
        error: null
      };

    case FETCH_COVERAGES_BY_GROUP_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case FETCH_COVERAGES_BY_GROUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        availableCoverages: action.payload
      };

    case FETCH_COVERAGE_GROUP_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case FETCH_COVERAGE_GROUP_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        coverageGroupDetail: action.payload,
        error: null
      };

    case FETCH_COVERAGE_GROUP_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        coverageGroupDetail: null,
        error: action.payload
      };

    case CREATE_COVERAGE_GROUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null
      };

    case EDIT_COVERAGE_GROUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null
      };

    case DELETE_COVERAGE_GROUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        coverageGroups: state.coverageGroups.filter(
          group => group.id !== action.payload
        ),
        error: null
      };

    case FETCH_COVERAGE_GROUPS_FAILURE:
    case FETCH_COVERAGES_BY_GROUP_FAILURE:
    case CREATE_COVERAGE_GROUP_FAILURE:
    case EDIT_COVERAGE_GROUP_FAILURE:
    case DELETE_COVERAGE_GROUP_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };

    case SET_SELECTED_COVERAGE_GROUP:
      return {
        ...state,
        coverageGroupSelected: action.payload
      };

    case ADD_COVERAGE_GROUP_MODE:
      return {
        ...state,
        addMode: true,
        deleteMode: false,
        coverageGroupSelected: null
      };

    case EDIT_COVERAGE_GROUP_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: false
      };

    case DELETE_COVERAGE_GROUP_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: true
      };

    case CLEAR_COVERAGE_GROUPS:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
